<template>
  <v-container fluid class="pt-3">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-center">
        <div class="pb-3">
          <el-select
            v-model="form.shop_reference"
            filterable
            placeholder="เลือกร้านค้า"
            :size="`small`"
            class="pr-2"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_reference"
              :label="item.name"
              :value="item.shop_reference"
            ></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="viewReport"
          >ค้นหา</el-button>
        </div>
      </v-flex>
    </v-layout>
    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:item.category_id="{item}">{{ item.category_id }}</template>
        <template v-slot:item.name="{item}">{{ item.name }}</template>
        <template v-slot:item.quantity="{item}">{{ item.quantity | numFormat('0,0') }}</template>
        <template v-slot:item.amount="{item}">{{ item.amount | numFormat('0,0.00') }}</template>
      </v-data-table>
    </el-card>
    <div style="position:fixed; bottom:10px; right:10px; z-index:9; width:100%;">
      <v-pagination circle v-model="page" :total-visible="5" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import Service from "../../services";

import moment from "moment";
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      form: {
        shop_reference: "",
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "category_id",
        },
        { text: "ชื่อหมวดหมู่", value: "name" },
        { text: "จำนวนการขาย", value: "quantity" },
        { text: "ยอดขาย", align: "right", value: "amount" },
      ],
      shopList: [],
      items: [],
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
    };
  },
  created() {
    Service.Shop.gets().then((res) => {
      if (res.success) {
        this.shopList = res.data.map((item) => {
          return {
            shop_reference: item.ref_no,
            name: item.name,
            status: item.status,
          };
        });

        this.shopList = this.shopList.filter(function (item) {
          return item.status == "published";
        });

        this.isLoading = false;
      }
    });
  },
  methods: {
    viewReport() {
      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        shop_reference: this.form.shop_reference,
      };

      Service.Report.category(data).then((res) => {
        this.items = res.data;
      });
    },
  },
};
</script>